import { Table, TableCell, TableHeader, TableHeaderCell, TableRow } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { NavLink } from 'react-router';
import { getUserNames } from '../../../common/string/get-user-names';
import { CountryAwardSummary } from '../../../models';
import { RoutePaths } from '../../../route-paths';
import './RegionAwardList.scss';

interface RegionAwardListProps {
  countryAwardSummaries: CountryAwardSummary[]
}

const RegionAwardListImpl: React.FC<RegionAwardListProps> = (props) => {
  const {
    countryAwardSummaries,
  } = props;

  return (
    <Table className='region-award-list'>
      <TableHeader>
        <TableRow>
          <TableHeaderCell className='col-award'>Award</TableHeaderCell>
          <TableHeaderCell>Award Lead</TableHeaderCell>
          <TableHeaderCell>Total Nominations</TableHeaderCell>
          <TableHeaderCell>AI Pending</TableHeaderCell>
          <TableHeaderCell>Pending Affirmation</TableHeaderCell>
          <TableHeaderCell className='col-winner'>Winner</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <tbody>
        {
          countryAwardSummaries.map((countryAwardSummary) => {
            return (
              <TableRow
                key={countryAwardSummary.awardId}
              >
                <TableCell className='col-award'>
                  <NavLink
                    to={RoutePaths.CountryAward + '/' + countryAwardSummary.awardId}
                    end
                  >
                    {countryAwardSummary.displayName}
                  </NavLink>
                </TableCell>
                <TableCell>{getUserNames(countryAwardSummary.leads)}</TableCell>
                <TableCell>{countryAwardSummary.numberOfNominations}</TableCell>
                <TableCell>{countryAwardSummary.numberOfPendingNominations}</TableCell>
                <TableCell>{countryAwardSummary.numberOfPendingAffirmationNominations}</TableCell>
                <TableCell className='col-winner'>{countryAwardSummary.winnerHasBeenAssigned ? 'Yes' : ''}</TableCell>
              </TableRow>
            );
          })
        }
      </tbody>
    </Table>
  );
}

export const RegionAwardList = observer(RegionAwardListImpl);
